module.exports = __webpack_public_path__ + "img/alex_competencies_grey.a6aee142.svg";